import { APIClient } from "../helpers/api_helper";
const api = new APIClient();

type LoginData = {
  identifier: string;
  password: string;
};

type ForgotPasswordData = {
  email: string;
};

export const login = ({
  identifier,

  password
}: LoginData) => {
  return api.create("/dashboard/auth/login", {
    email: identifier,
    password
  });

};

export const forgotPassword = ({
  email
}: ForgotPasswordData) => {
  return api.create("/auth/forgot-password-mobile", {
    email
  });
};

export const changeForgottenPassword = ({
  code,
  password,
  passwordConfirmation
}) => {
  return api.create("/auth/reset-password", {
    password,
    passwordConfirmation,
    code
  });

};

export const changePassword = ({
  currentPassword,
  password,
  passwordConfirmation
}) => {
  return api.create("/auth/change-password", {
    currentPassword,
    password,
    passwordConfirmation
  });
};

export const refreshToken = (data) => {
  return api.create("/token/refresh", data);
};
